import InvoicePage, { InvoiceDetailPage } from './pages/InvoicePage'
import OfficesPage from './pages/OfficesPage'
import ReferencePage from './pages/ReferencePage'
import ReportsPage from './pages/ReportsPage'
import ImportCheckPage from './pages/ImportCheckPage'
import { CommissionCheckPage, CommissionRunPage } from './pages/CommissionChecks'
import { BspRunPage } from './pages/BspRuns'
import { AccountingProviders } from './providers'

function withProviders(Page: () => JSX.Element) {
  return function AccountingRoute() {
    return (
      <AccountingProviders>
        <Page />
      </AccountingProviders>
    )
  }
}

export const AccountingInvoice = withProviders(InvoicePage)
export const AccountingInvoiceDetail = withProviders(InvoiceDetailPage)
export const AccountingOffices = withProviders(OfficesPage)
export const AccountingFormsOfPayment = withProviders(() => <ReferencePage kind="forms-of-payment" />)
export const AccountingSuppliers = withProviders(() => <ReferencePage kind="suppliers" />)
export const AccountingTransactionTypes = withProviders(() => <ReferencePage kind="transaction-types" />)
export const AccountingReports = withProviders(ReportsPage)
export const AccountingImportCheck = withProviders(ImportCheckPage)
export const AccountingCommissionRun = withProviders(CommissionRunPage)
export const AccountingCommissionCheck = withProviders(CommissionCheckPage)
export const AccountingBspRun = withProviders(BspRunPage)
